module.exports = __webpack_public_path__ + "img/togo.4fd462b.webp";